import { type ClipsListOptions } from '@air/api/types';

import { useClipsFilters } from '~/hooks/filters/useClipsFilters';
import { useSearchParams } from '~/hooks/search/useSearchParams';

export type UseClipSearchParamsProps = {
  semantic?: boolean;
  hybrid?: boolean;
};

export type UseClipSearchParamsReturn = Partial<
  Pick<ClipsListOptions, 'withOpenDiscussionStatus' | 'filters' | 'search' | 'boardId' | 'semantic' | 'types'>
>;

export const useClipSearchParams = ({ semantic, hybrid }: UseClipSearchParamsProps = {}): UseClipSearchParamsReturn => {
  const { search } = useSearchParams();
  const { filtersParams, requiresSemanticSearch } = useClipsFilters();

  return {
    withOpenDiscussionStatus: true,
    filters: filtersParams,
    search,
    boardId: filtersParams.board?.is || filtersParams.boardTree?.is,
    ...(semantic !== undefined && {
      // WORKAROUND: The API returns no clips when semantic=true with an empty search term.
      // To show clips when there's no search term, we force semantic=false in that case.
      semantic: requiresSemanticSearch ? true : search === undefined ? false : semantic,
    }),
    ...(hybrid !== undefined && {
      hybrid,
    }),
  };
};
